import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type OmniSearchOrdersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CombinedOrderDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type OmniSearchOrdersQuery = { __typename?: 'Query', combinedOrders?: { __typename?: 'CombinedOrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CombinedOrderDocument', orderEntityType: Types.OrderEntityType, orderEntityId: string, orderEntityNumber: string, customerName: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type OmniSearchCustomersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomersSummaryDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type OmniSearchCustomersQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, name: string, erpId: string, customerLookupCode: string, primaryContactPhone: string, contactSearchEntries: Array<{ __typename?: 'CustomerContactSearchEntry', contactId: string, name: string, phone: string, phoneDigits: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type OmniSearchItemsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type OmniSearchItemsQuery = { __typename?: 'Query', items?: { __typename?: 'ItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', itemId: string, name: string, sku: string, upc: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const OmniSearchOrdersDocument = new TypedDocumentString(`
    query OmniSearchOrders($where: CombinedOrderDocumentFilterInput, $first: Int) {
  combinedOrders(where: $where, first: $first) {
    nodes {
      orderEntityType
      orderEntityId
      orderEntityNumber
      customerName
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const OmniSearchCustomersDocument = new TypedDocumentString(`
    query OmniSearchCustomers($where: CustomersSummaryDocumentFilterInput, $first: Int) {
  customers(where: $where, first: $first) {
    nodes {
      customerId
      name
      erpId
      customerLookupCode
      primaryContactPhone
      contactSearchEntries {
        ...CustomerContactSearchEntry
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment CustomerContactSearchEntry on CustomerContactSearchEntry {
  contactId
  name
  phone
  phoneDigits
}`);
export const OmniSearchItemsDocument = new TypedDocumentString(`
    query OmniSearchItems($search: String, $where: ItemSummaryDocumentFilterInput, $first: Int) {
  items(search: $search, where: $where, first: $first) {
    nodes {
      itemId
      name
      sku
      upc
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    OmniSearchOrders: build.query<OmniSearchOrdersQuery, OmniSearchOrdersQueryVariables | void>({
      query: (variables) => ({ document: OmniSearchOrdersDocument, variables })
    }),
    OmniSearchCustomers: build.query<OmniSearchCustomersQuery, OmniSearchCustomersQueryVariables | void>({
      query: (variables) => ({ document: OmniSearchCustomersDocument, variables })
    }),
    OmniSearchItems: build.query<OmniSearchItemsQuery, OmniSearchItemsQueryVariables | void>({
      query: (variables) => ({ document: OmniSearchItemsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useOmniSearchOrdersQuery, useLazyOmniSearchOrdersQuery, useOmniSearchCustomersQuery, useLazyOmniSearchCustomersQuery, useOmniSearchItemsQuery, useLazyOmniSearchItemsQuery } = injectedRtkApi;
